import React from "react";
import { FormattedText, ParaTag, FlexComp, AnchorTag } from "@tm/static";
import CommonModalDweb from "../CommonModalDweb/CommonModalDweb";

interface SegmentModalProps {
  modal: {
    icon?: string;
    title?: string;
    description?: any;
    primaryCtaText?: any;
    secondaryCtaText?: any;
  };
  onClose: () => void;
  onPrimaryCta?: () => void;
  onSecondaryCta?: () => void;
}

const SegmentModal: React.FC<SegmentModalProps> = ({ modal, onClose, onPrimaryCta, onSecondaryCta }) => {
  if (!modal) return null;
  return (
    <CommonModalDweb
      customIcon={modal.icon}
      customTitle={modal.title}
      handleClick={onClose}
      nonClipHeading
    >
      <ParaTag fontSize="md" color="#757575" margin="0 0 36px">
        <FormattedText value={modal.description} />
      </ParaTag>
      <FlexComp justifyContent="space-between" alignItems="center">
        <AnchorTag
          handleClick={onSecondaryCta || onClose}
          fontSize="md"
          fontWeight="bold"
        >
          <FormattedText value={modal.secondaryCtaText} />
        </AnchorTag>
        <AnchorTag
          handleClick={onPrimaryCta || onClose}
          fontSize="md"
          fontWeight="bold"
        >
          <FormattedText value={modal.primaryCtaText} />
        </AnchorTag>
      </FlexComp>
    </CommonModalDweb>
  );
};

export default SegmentModal; 